import { param } from "jquery";
import LinkFormsServices from "../../services/LinkFormsServices";
import QuotingServices from "../../services/QuotingServices";
import vm from '@/main.js'
const state = {
    loadingExternal: false,
    externalFvc: null
};

const getters = {
    externalFvc: state => {
        return state.externalFvc;
    },
    loadingExternal: state => {
        return state.loadingExternal;
    }
};

const actions = {

    external(context) {
        context.commit("showLoadingIndicator");
        const profile = context.rootGetters.userProfile;
        const agencyId= context.rootGetters.agencyId;
        return QuotingServices.external(profile,agencyId)
            .then(response => {
                if (response.data.error == 0) {          
                    state.externalFvc = response.data.data[6];

                } else if (response.data.error == 100) {
                    vm.$root.$emit("showSnackBar", "Error interno:" + response.data.msg, "error");
                }
            })
            .catch((res) => {
                vm.$root.$emit("showSnackBar", "Error desconocido", "error");
            })
            .finally(res => {
                context.commit("hideLoadingIndicator");
            });
    },
    
};

const mutations = {
    showLoadingIndicator(state) {
        state.loadingExternal = true;
    },
    hideLoadingIndicator(state) {
        state.loadingExternal = false;
    },
};

export default {
    state,
    getters,
    actions,
    mutations
};